import {
  ADD_FAMILY_USER_ROLE,
  AddFamilyUserRole,
  DELETE_FAMILY_USER_ROLE,
  DeleteFamilyUserRole,
  FamilyUserRole,
  QUERY_FAMILY_USER_ROLES,
  QueryFamilyUserRoles,
  UPDATE_FAMILY_USER_ROLE,
  UpdateFamilyUserRole,
} from './types';

export const queryFamilyUserRoles = (roles: FamilyUserRole[]): QueryFamilyUserRoles => {
  return {
    type: QUERY_FAMILY_USER_ROLES,
    payload: roles,
  };
};

export const deleteFamilyUserRole = (roleId: string): DeleteFamilyUserRole => {
  return {
    type: DELETE_FAMILY_USER_ROLE,
    payload: roleId,
  };
};

export const addFamilyUserRole = (role: FamilyUserRole): AddFamilyUserRole => {
  return {
    type: ADD_FAMILY_USER_ROLE,
    payload: role,
  };
};

export const updateFamilyUserRole = (roleId: string, updated: FamilyUserRole): UpdateFamilyUserRole => {
  return {
    type: UPDATE_FAMILY_USER_ROLE,
    payload: { roleId, updated },
  };
};
